// Selector de descargas
export const selectDownloadsState = (state) => state.descargas;

export const selectLinksState = (state) => state.descargas;
